module.exports = __webpack_public_path__ + "img/ctm.e7dc217f.svg";